import AbstractRestApi from '@/api/RestApi/AbstractRestApi'
import ResponseHandler from '@/api/response/ResponseHandler'
import apiClient from '@/api/ApiClient'

class TabletAutoLoginApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/restaurant-tablet-auto-logins'
    }

    updateUser(id, userId, name) {
        return ResponseHandler.handle(
            apiClient.post(
                '/api/v1/restaurant-tablet/' + id + '/update',
                { userId, name }
            )
        )
    }
}

export default new TabletAutoLoginApiClient()
